import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class UserService {
    user: any;
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) {
    }
    createUser(user: any) {
        return this.http.post(this.config.apiUrl + 'user/create', user, this.setHeaders()).map((response: Response) => response.json());
    }
    forgotPassword(user: any) {
        return this.http.post(this.config.apiAuthUrl + 'user/forgot-password', user, this.setHeaders()).map((response: Response) => response.json());
    }
    resetPassword(user: any) {
        return this.http.post(this.config.apiUrl + 'user/change-password', user, this.setHeaders()).map((response: Response) => response.json());
    }
    getAll(userCurrentPage: number, maxSize: any, filter: any) {
        return this.http.post(this.config.apiUrl + 'user/get-all?page=' + userCurrentPage + '&limit=' + maxSize, filter, this.setHeaders()).map((response: Response) => response.json());
    }
    getPrecessor(request: any) {
        return this.http.post(this.config.apiUrl + 'user/get-precessor-by-role', request, this.setHeaders()).map((response: Response) => response.json());
    }
    getSuccessor(id: any) {
        return this.http.get(this.config.apiUrl + 'user/get-successor/' + id, this.setHeaders()).map((response: Response) => response.json());
    }
    deleteUser(id: any) {
        return this.http.put(this.config.apiUrl + 'user/delete', { id: id }, this.setHeaders()).map((response: Response) => response.json());
    }
    activateUser(id: any) {
        return this.http.put(this.config.apiUrl + 'user/activate', { id: id }, this.setHeaders()).map((response: Response) => response.json());
    }
    findById(id: any) {
        return this.http.post(this.config.apiUrl + 'user/findById', { id: id }, this.setHeaders()).map((response: Response) => response.json());
    }
    uploadPhoto() {
        return this.http.post(this.config.apiUrl + 'user/upload', this.setHeaders()).map((response: Response) => response.json());
    }
    getAllDocumentByUser(req) {
        return this.http.post(this.config.apiUrl + 'document/find-all-by-user', req, this.setHeaders()).map((response: Response) => response.json());
    }
    findAllDocument() {
        return this.http.post(this.config.apiUrl + 'document/find-all', {}, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllSuccessor() {
        return this.http.get(this.config.apiUrl + 'user/get-all-successor/', this.setHeaders()).map((response: Response) => response.json());
    }
    replaceOwner(owner: any) {
        return this.http.post(this.config.apiUrl + 'owner/replace-owner', owner, this.setHeaders()).map((response: Response) => response.json());
    }
    replaceAccountOwner(owner: any, file: any) {
        return this.http.post(this.config.apiUrl + 'user/replace-account-manager?manager='+owner.new_owner_bulk, file, this.setHeaders()).map((response: Response) => response.json());
    }
    updateUser(user: any) {
        return this.http.put(this.config.apiUrl + 'user/update', user, this.setHeaders()).map((response: Response) => response.json());
    }
    deleteDocument(id: any) {
        return this.http.get(this.config.apiUrl + 'document/delete/' + id, this.setHeaders())
    }
    exportCreditReport(userCurrentPage: number, maxSize: any, filter: any) {
        const params: any = new URLSearchParams();
        if (Object.keys(filter).length > 0) {
            for (const entries of Object.entries(filter)) {
                const key = entries[0];
                const value = entries[1];
                if(entries[1]){
                    params.append(key, value);
                }
              
            }
        }
        return this.http.get(this.config.apiUrl + 'user/credit-report?page=' + userCurrentPage + '&limit=' + maxSize, this.setHeaders(params))
            .map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if (params)
                return new RequestOptions({ headers: headers, search: params });
            else
                return new RequestOptions({ headers: headers });
        } else {
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/user.service.ts